import { Currency, Utils } from 'types';
import store from '@/store';

const CACHE_VALIDITY_PERIOD = 5 * 60 * 1000; // 5 minutes

export namespace ExchangeService {
  export const performConversion = async (params: {
    amount: number;
    from: Currency.CURRENCIES;
    to: Currency.CURRENCIES;
  }): Promise<{
    amount: number;
    from: Currency.CURRENCIES;
    to: Currency.CURRENCIES;
    rate: number;
  }> => {
    let exchangeRates: Utils.CurrencyExchange.Rates =
      store.state.support.exchangeRates;

    if (
      !exchangeRates ||
      (exchangeRates.base !== params.to &&
        exchangeRates.base !== params.from) ||
      new Date().getTime() - new Date(exchangeRates?.createdAt)?.getTime() <
        CACHE_VALIDITY_PERIOD
    ) {
      const { currencies } = await store.dispatch(
        'support/getInfoUtils',
        {},
        { root: true },
      );
      exchangeRates = currencies;
    }

    const base = {
      from: params.from,
      to: params.to,
    };

    if (params.to === exchangeRates.base) {
      const rate = exchangeRates[params.from];
      const amout = params.amount / rate;
      return {
        ...base,
        amount: amout,
        rate: amout / params.amount,
      };
    }

    const rate = exchangeRates[params.to];
    return {
      ...base,
      amount: params.amount * rate,
      rate,
    };
  };
}
